module.exports = __webpack_public_path__ + "static/media/km-history-table-blurred.0309cf8f.png";